import dayjs from 'dayjs'
import _ from 'lodash'

function parsePatentFunc (entities) {
  entities.forEach(item => {
    let time = item.applicationPublishTime
    time = time.replace(/\./g, '-')
    item.applicationPublishTime = dayjs(time).format('YYYY-MM-DD')
  })
}

function parseIcpFunc (entities) {
  entities.forEach(item => {
    let webSites = item.webSite
    item.webSite = webSites.join(',')
  })
}

function parseOpenNoticeFunc (entities) {
  entities.forEach(item => {
    let plaintiff = item.plaintiff || []
    let defendant = item.defendant || []
    item.plaintiff = plaintiff.map(p => { return p.name || '' }).join('，')
    item.defendant = defendant.map(p => { return p.name || '' }).join('，')
  })
}

function parseInvestmentFunc (entities) {
  entities.forEach(item => {
    let amount = item.amount === '0' ? '未公开' : item.amount
    item.amount = amount
  })
}

function parseChangeRecordFunc (entities) {
  entities.forEach(item => {
    let contentBefore = item.contentBefore
    if (contentBefore) {
      contentBefore = contentBefore.replace(/<em>/g, '')
      item.contentBefore = contentBefore.replace(/<\/em>/g, '')
    }
    let contentAfter = item.contentAfter
    if (contentAfter) {
      contentAfter = contentAfter.replace(/<em>/g, '')
      item.contentAfter = contentAfter.replace(/<\/em>/g, '')
    }
  })
}

function parseExecutiveFunc (entities) {
  let data = [...entities]
  entities.length = 0
  let groups = _.chunk(data, 2)
  groups = groups.map(g => {
    let g1 = g[0]
    let g2 = g[1] || { typeJoin: [] }
    return {
      name: g1.name,
      join: g1.typeJoin.join(','),
      name1: g2.name || '$space',
      join1: g2.typeJoin.join(',') || '$space'
    }
  })
  entities.push(...groups)
}

function parseShareholderFunc (entities) {
  entities.forEach(item => {
    let capitals = item.capital
    if (capitals && Array.isArray(capitals) && capitals.length > 0) {
      let capital = capitals[0]
      Object.assign(item, capital)
    }
  })
}

const funcs = {
  patent: parsePatentFunc,
  icp: parseIcpFunc,
  openNotice: parseOpenNoticeFunc,
  shareholder: parseShareholderFunc,
  executive: parseExecutiveFunc,
  changeRecord: parseChangeRecordFunc,
  investment: parseInvestmentFunc

}

export default Object.freeze(funcs)
